import LivePage from '../components/LivePage/LivePage'
import NotFound from '../components/NotFound'
import { logServerSidePropsError } from '../components/utilities/log-helper'
import { fetchLivestreamData } from '../config/livestreamAuth'
import regions from '../config/regions'
import fetchQueryWrapper from '../core/fetchQueryWrapper'
import extractLivepage from '../data/transformers/extractLivepage'
import { RouteRedMetrics } from '../utils/metrics'

export default ({ topStories, metadata, withAds, livestream, providers, error }) => {
  if (error) {
    return <NotFound />
  }

  return (
    <LivePage
      topStories={topStories}
      metadata={metadata}
      withAds={withAds}
      livestream={livestream}
      providers={providers}
    />
  )
}

export const paramsForLivePage = regionId => ({
  content_type: 'livePage',
  'fields.region.sys.id': regionId,
  include: 4
})

export async function getServerSideProps(context) {
  // _app's getInitialProps runs first and may have already redirected (e.g. apex domain -> region subdomain)
  if (context?.res?.writableEnded || context?.res?.headersSent) {
    return { props: {} }
  }

  const redMetrics = new RouteRedMetrics({
    method: 'GET',
    route: 'live'
  }).start()

  try {
    const regionName = context?.req?.headers?.host?.split('.')?.[0]
    const regionId = regions[regionName]?.contentfulId || regions.default.contentfulId

    const livePageData = await fetchQueryWrapper(paramsForLivePage(regionId), extractLivepage)
    const { providers, livestream } = await fetchLivestreamData(context, regionId)

    const surrogateKeyHeader = context?.res?.getHeader('Surrogate-Key')?.split(' ')
    const surrogateKeys = [...surrogateKeyHeader, ...livePageData?.storyIDs, livePageData?.id].filter(Boolean).join(' ')
    context?.res?.setHeader('Surrogate-Key', surrogateKeys)

    redMetrics.end({
      status: 200
    })

    context.res.chartbeatType = 'livePage'

    return {
      props: {
        topStories: livePageData.topStories,
        metadata: livePageData.metadata,
        withAds: livePageData.withAds,
        livestream,
        providers
      }
    }
  } catch (error) {
    logServerSidePropsError(error)

    redMetrics.end({
      status: 500,
      error: 'Failed to load page'
    })

    return { props: { error } }
  }
}
